/**
 * Leitura do `logout_token` que o Zitadel anexa à logout URL V2.
 *
 * É um JWT assinado pelo Zitadel cujo payload traz o `sid` — o id da sessão V2
 * que a nossa UI criou no login. Só lemos o claim (não validamos assinatura):
 * o valor não autoriza nada por si, ele apenas nos diz QUAL sessão apagar, e o
 * DELETE em si é autorizado pelo PAT do `login-client` no proxy. Um `sid`
 * forjado no máximo derrubaria uma sessão alheia já conhecida por quem forjou.
 */
export function extrairSessionId(search: string): string | null {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  const token = params.get('logout_token');
  if (!token) return null;

  const payload = decodificarPayload(token);
  const sid = payload?.['sid'];
  return typeof sid === 'string' && sid.length > 0 ? sid : null;
}

function decodificarPayload(jwt: string): Record<string, unknown> | null {
  const partes = jwt.split('.');
  if (partes.length < 2) return null;

  try {
    // base64url → base64, com o padding que o atob exige.
    const b64 = partes[1].replace(/-/g, '+').replace(/_/g, '/');
    const json = atob(b64.padEnd(b64.length + ((4 - (b64.length % 4)) % 4), '='));
    const parsed: unknown = JSON.parse(json);
    return typeof parsed === 'object' && parsed !== null
      ? (parsed as Record<string, unknown>)
      : null;
  } catch {
    return null;
  }
}
